import SequencingStep from './SequencingStep';

export default SequencingStep;
